/**
 * @generated SignedSource<<40caa85fbf09faca7c85f97236a2831b>>
 * @relayHash 3d577e8c7fa1e2d264b5bf388496b414
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 404eb064bc9f6a836d7b8f5a6c57123b409feeb20c6c2ea35765add2608e3da5

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newOrganizationPageQuery$variables = Record<PropertyKey, never>;
export type newOrganizationPageQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"selectsDataWrapperProviderAccountsFragment">;
  };
};
export type newOrganizationPageQuery = {
  response: newOrganizationPageQuery$data;
  variables: newOrganizationPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "newOrganizationPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "selectsDataWrapperProviderAccountsFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "newOrganizationPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OrganizationConnection",
            "kind": "LinkedField",
            "name": "organizations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3d577e8c7fa1e2d264b5bf388496b414",
    "id": "404eb064bc9f6a836d7b8f5a6c57123b409feeb20c6c2ea35765add2608e3da5",
    "metadata": {},
    "name": "newOrganizationPageQuery",
    "operationKind": "query",
    "text": "query newOrganizationPageQuery {\n  viewer {\n    ...selectsDataWrapperProviderAccountsFragment\n    id\n  }\n}\n\nfragment accountSelectFragment on User {\n  name\n  organizations {\n    nodes {\n      slug\n      name\n      id\n    }\n  }\n}\n\nfragment selectsDataWrapperProviderAccountsFragment on User {\n  ...accountSelectFragment\n}\n"
  }
};
})();

(node as any).hash = "056f3de7192aa7b667e19138eda41002";

export default node;
